<template>
	<div class="list-number"
		:style="`border: solid 2px ${ enabled ? $appColors.primary : $appColors.gray};`"
	  :class='{ "process-disabled": !enabled }'
	>
		<div class="numbers" :style="`color:${$appColors.info}`">
			<div v-html='data.description'></div>
		</div>
		<button
			class="btn" @click="onButtonClick"
			:style="`background-color: ${ enabled ? $appColors.primary : $appColors.gray}`"
			:disabled="!enabled"
		>
			Empezar
		</button>
	</div>
</template>
<script>
export default {
	name: 'box-blue',
	props: {
		data: {
			type: Object,
			default: () => {},
		},
		enabled: {
			type: Boolean,
		},
	},
	methods: {
		onButtonClick() {
			this.goTo(this.data.goTo);
		},
	},
};
</script>
<style lang="scss" scoped>
	.list-number {
		border-radius: 5px;
		min-width: 238px;
		padding-top: 30px;
		overflow: hidden;
		box-sizing: content-box;
	}

	.btn {
		color: map-get($colors, white);
		font-family: map-get($fonts, bold);
		font-size: map-get($sizes, xlarge);
		height: 100%;
		padding: 10px 0;
		width: 100%;
	}

	.numbers {
		margin-bottom: 30px;
		padding: 0 37px 0 27px;
	}
</style>





// WEBPACK FOOTER //
// src/modules/job-evaluation/components/box-blue.vue